module.exports = __webpack_public_path__ + "img/collar edges length.05ad68e8.png";